import { TextPlatformSelectorType } from '@pages/app/social/components/new-post/TextPlatformSelector';

import { IFindAllBrands } from './response';

export enum ESocialPlatforms {
  Bluesky = 'bluesky',
  Facebook = 'facebook',
  GMB = 'gmb',
  Instagram = 'instagram',
  LinkedIn = 'linkedin',
  Pinterest = 'pinterest',
  Reddit = 'reddit',
  Threads = 'threads',
  TikTok = 'tiktok',
  Twitter = 'twitter',
  YouTube = 'youtube',
  Telegram = 'telegram',
}
export const SOCIAL_PLATFORMS = Object.values(ESocialPlatforms);
export type SocialPlatform = (typeof SOCIAL_PLATFORMS)[number];

export enum EPostType {
  Regular = 'post',
  Reel = 'reel',
  Story = 'story',
  GMB = 'gmb',
  Off = 'off platform',
  Carousel = 'carousel',
  Draft = 'draft',
}
export const POST_TYPE = Object.values(EPostType);
export type PostType = (typeof POST_TYPE)[number];
export type TCreatePostType = EPostType.Regular | EPostType.Reel | EPostType.Story | EPostType.Carousel;

export enum EBrandStatus {
  ACTIVE = 'ACTIVE',
  SUSPENDED = 'SUSPENDED',
}
export const BRAND_STATUS = Object.values(EBrandStatus);
export type BrandStatus = (typeof BRAND_STATUS)[number];

export const AvailableForReel = [ESocialPlatforms.Facebook, ESocialPlatforms.Instagram, ESocialPlatforms.YouTube];

export const AvailableForStory = [ESocialPlatforms.Facebook, ESocialPlatforms.Instagram];

export const LabelByPlatform: Record<SocialPlatform, string> = {
  [ESocialPlatforms.Bluesky]: 'Bluesky',
  [ESocialPlatforms.Facebook]: 'Facebook',
  [ESocialPlatforms.GMB]: 'Google',
  [ESocialPlatforms.Instagram]: 'Instagram',
  [ESocialPlatforms.LinkedIn]: 'LinkedIn',
  [ESocialPlatforms.Pinterest]: 'Pinterest',
  [ESocialPlatforms.Reddit]: 'Reddit',
  [ESocialPlatforms.Threads]: 'Threads',
  [ESocialPlatforms.TikTok]: 'TikTok',
  [ESocialPlatforms.Twitter]: 'Twitter / X',
  [ESocialPlatforms.YouTube]: 'YouTube',
  [ESocialPlatforms.Telegram]: 'Telegram',
};

export const PublishersByType: Record<EPostType, ESocialPlatforms[]> = {
  [EPostType.Regular]: SOCIAL_PLATFORMS.filter((platform) => platform !== ESocialPlatforms.Reddit),
  [EPostType.Reel]: AvailableForReel,
  [EPostType.Story]: AvailableForStory,
  [EPostType.GMB]: [ESocialPlatforms.GMB],
  [EPostType.Carousel]: [ESocialPlatforms.Facebook],
  [EPostType.Off]: [],
  [EPostType.Draft]: [],
};
export const INewPostFormVersion = '0.0.1'; // Update version if change INewPostForm interface
export const DEFAULT_TEXT_PLATFORM_SELECTOR = 'all';
export interface TextPlatform {
  text: string;
  plainText: string;
  isCustom: boolean;
}

export interface ICarouselAsset {
  picture: string;
  name: string;
  link: string;
  id: string;
  index: number;
}
export interface INewPostFormV000 {
  post: string;
  plainText: string;
  platforms: SocialPlatform[];
  scheduleDate?: string;
  type: TCreatePostType;
  media: ISocialMedia[];
  facebookOptions?: EFacebookPostType;
  instagramOptions?: EInstagramPostType;
  pedId?: number;
  carousel: ICarouselAsset[];
  gmbOptions?: {
    type: E_GMBPostType;
    category: E_GMBCategory;
    cta: E_GMBCTA;
    ctaUrl: string;
  };
  extra?: {
    ai_content: boolean;
  };
}

export interface ISocialMedia {
  type: string;
  url: string;
  size?: number;
  file?: File;
}
export interface INewPostForm extends INewPostFormV000 {
  customPost: Partial<Record<TextPlatformSelectorType, TextPlatform>> &
    Record<typeof DEFAULT_TEXT_PLATFORM_SELECTOR, TextPlatform>;
  extra?: {
    ai_content: boolean;
    ai_prompt?: string;
    selectedTextPlatform: TextPlatformSelectorType;
    showTextErrors: boolean;
    showImageErrors: boolean;
    carouselLink: string;
    pedTopic?: string;
  };
}

export interface IPaginationSchema {
  currentPage: number;
  pageSize: number;
  totalItems: number;
}

export const mockPaginationSchema: IPaginationSchema = {
  currentPage: 1,
  pageSize: 10,
  totalItems: 100,
};

// export interface IPost {
//   // Required fields
//   id?: string;
//   post?: string; // The text content of the post
//   platforms: SocialPlatform[]; // Array of social media platforms to post to (e.g. ["twitter", "facebook"])

//   // Optional fields for media
//   mediaUrls?: string[]; // URLs of images/videos to include
//   mediaType?: 'image' | 'video'; // Specify if the media is image or video

//   // Scheduling options
//   scheduleDate?: string; // ISO date string for scheduled posts

//   // Testing helpers
//   randomPost?: boolean; // Generate random post text
//   randomMediaUrl?: boolean; // Include random media
//   isLandscapeVideo?: boolean; // For random test videos in landscape
//   isPortraitVideo?: boolean; // For random test videos in portrait

//   // Rich media options
//   title?: string; // Title for the post (supported platforms)
//   altText?: string; // Alternative text for images
//   mediaCaption?: string; // Caption for media
//   videoThumbnail?: string; // Custom thumbnail URL for videos

//   // Additional features
//   shortenLinks?: boolean; // Auto-shorten links in post
//   autoHashtags?: boolean; // Auto-generate relevant hashtags
//   idempotencyKey?: string; // Unique key to prevent duplicate posts

//   // Platform specific
//   twitterOptions?: {
//     thread?: boolean; // Create Twitter thread for long posts
//   };

//   facebookOptions?: {
//     reels?: boolean; // Post as Facebook Reel
//   };

//   instagramOptions?: {
//     reels?: boolean; // Post as Instagram Reel
//     stories?: boolean; // Post as Instagram Story
//   };
// }

export const _brandEmptyValues: IFindAllBrands = {
  id: -1,
  name: '',
  description: '',
  websiteUrl: '',
  messagingEnabled: null,
  country: null,
};

export enum EFacebookPostType {
  Post = 'post', // solo testo, 1+ immagini, 1+ video, mixed
  Story = 'story', // Se seleziona questo -> 1 immagine oppure 1 video
  Reel = 'reel', // Se seleziona questo -> SOLO UN VIDEO, nessun altra opzione
  ImageCarousel = 'image carousel', // Per ora non lo mostriamo
}

export enum EInstagramPostType {
  Post = 'post', // 1+ immagini, 1+ video, mixed. Non esiste solo testo qui
  Story = 'story', // Se seleziona questo -> 1 immagine oppure 1 video
  Reel = 'reel', // Se seleziona questo -> SOLO UN VIDEO, nessun altra opzione
}

export enum E_GMBPostType {
  Post = 'post', // testo, immagine, video, anche con CTA
  Category = 'category', // foto o video piu categoria di appartenenza
  Event = 'event', // foto o video con data inizio e data fine
  Offer = 'offer', // foto o video con data inizio e data fine
}

export enum E_GMBCategory {
  Cover = 'cover',
  Profile = 'profile',
  Logo = 'logo',
  Exterior = 'exterior',
  Interior = 'interior',
  Product = 'product',
  AtWork = 'at_work',
  FoodAndDrink = 'food_and_drink',
  Menu = 'menu',
  CommonArea = 'common_area',
  Rooms = 'rooms',
  Teams = 'teams',
}

export enum E_GMBCTA {
  Book = 'book',
  Order = 'order',
  Shop = 'shop',
  LearnMore = 'learn_more',
  SignUp = 'sign_up',
  Call = 'call',
}

export interface INewPostRules {
  maxTextLength: number | undefined;
  minAssetsLength: number | undefined;
  maxAssetsLength: number | undefined; //null means no limit
  acceptedContent: EContentType[];
  mandatoryContent: EContentType[];
}

export const SOCIAL_STATUS = ['success', 'error', 'processing', 'pending', 'deleted', 'awaiting approval'];

export enum ESocialPostStatus {
  SUCCESS = 'success',
  ERROR = 'error',
  PROCESSING = 'processing',
  PENDING = 'pending',
  /** Not a publication status the endpoint knows — see PAUSED in `parseFindPostRequest`. */
  PAUSED = 'paused',
  DELETED = 'deleted',
  AWAITING_APPROVAL = 'awaiting approval',
  SCHEDULED = 'scheduled',
  /** UI-only sentinel for "no status filter" — never sent. See ALL in `parseFindPostRequest`. */
  ALL = 'all',
}

/**
 * The value a single-select status control shows for `IPostsFiltersDrawer.status`.
 *
 * The filter is a list because the endpoint takes a list, but the older controls — the planner's
 * toggle group, Engage's tab — pick one status at a time, so they need the scalar back. Anything
 * that is not exactly one status reads as "no filter", which is what `ALL` means to them.
 */
export const toSingleStatus = (status: ESocialPostStatus[]): ESocialPostStatus =>
  status.length === 1 ? status[0] : ESocialPostStatus.ALL;

/** The list form of a single-select choice. `ALL` means "no status filter", so it selects nothing. */
export const fromSingleStatus = (status: ESocialPostStatus): ESocialPostStatus[] =>
  status === ESocialPostStatus.ALL ? [] : [status];

export enum EContentType {
  VIDEO = 'video',
  IMAGE = 'image',
  TEXT = 'text',
  CAROUSEL = 'carousel',
  LINK = 'link',
}

export const NON_DELETABLE_PLATFORMS = [ESocialPlatforms.Instagram, ESocialPlatforms.TikTok];

export const allAssetsTypes = [EContentType.VIDEO, EContentType.IMAGE];

export const POST_RULES = {
  [ESocialPlatforms.Bluesky]: {
    [EPostType.Regular]: {
      maxTextLength: 300,
      maxAssetsLength: 4,
      acceptedContent: [EContentType.TEXT, EContentType.IMAGE, EContentType.VIDEO],
    } as INewPostRules,
  },
  [ESocialPlatforms.Facebook]: {
    [EPostType.Story]: {
      maxAssetsLength: 1,
      acceptedContent: [EContentType.IMAGE, EContentType.VIDEO],
    } as INewPostRules,
    [EPostType.Regular]: {
      acceptedContent: [EContentType.TEXT, EContentType.IMAGE, EContentType.VIDEO],
    } as INewPostRules,
    [EPostType.Reel]: {
      maxAssetsLength: 1,
      acceptedContent: [EContentType.VIDEO, EContentType.TEXT],
    } as INewPostRules,
  },
  [ESocialPlatforms.GMB]: {
    [EPostType.Regular]: {
      maxAssetsLength: 1,
      acceptedContent: [EContentType.TEXT, EContentType.IMAGE],
    } as INewPostRules,
  },
  [ESocialPlatforms.Instagram]: {
    [EPostType.Regular]: {
      acceptedContent: [EContentType.IMAGE, EContentType.VIDEO, EContentType.TEXT],
      minAssetsLength: 1,
    } as INewPostRules,
    [EPostType.Story]: {
      maxAssetsLength: 1,
      acceptedContent: [EContentType.TEXT, EContentType.VIDEO, EContentType.IMAGE],
    } as INewPostRules,
    [EPostType.Reel]: {
      maxAssetsLength: 1,
      acceptedContent: [EContentType.VIDEO, EContentType.TEXT],
    } as INewPostRules,
  },
  [ESocialPlatforms.Pinterest]: {
    [EPostType.Regular]: {
      acceptedContent: [EContentType.TEXT, EContentType.IMAGE],
      minAssetsLength: 1,
    } as INewPostRules,
  },
  [ESocialPlatforms.Threads]: {
    [EPostType.Regular]: {
      maxTextLength: 500,
      maxAssetsLength: 20,
      acceptedContent: [EContentType.TEXT, EContentType.IMAGE, EContentType.VIDEO],
    } as INewPostRules,
  },
  [ESocialPlatforms.Twitter]: {
    [EPostType.Regular]: {
      maxTextLength: 280,
      maxAssetsLength: 4,
      acceptedContent: [EContentType.TEXT, EContentType.IMAGE, EContentType.VIDEO],
    } as INewPostRules,
  },
  [ESocialPlatforms.YouTube]: {
    [EPostType.Regular]: {
      acceptedContent: [EContentType.VIDEO, EContentType.TEXT],
      minAssetsLength: 1,
      maxAssetsLength: 1,
      mandatoryContent: [EContentType.VIDEO],
    } as INewPostRules,
  },
};

export const allowedTextFormatPlatforms = [
  ESocialPlatforms.Bluesky,
  ESocialPlatforms.Facebook,
  ESocialPlatforms.Instagram,
  ESocialPlatforms.LinkedIn,
  ESocialPlatforms.Reddit,
  ESocialPlatforms.Threads,
  ESocialPlatforms.Twitter,
];

export const allowedMentionPlatforms = [
  ESocialPlatforms.Bluesky,
  ESocialPlatforms.Facebook,
  ESocialPlatforms.LinkedIn,
  ESocialPlatforms.Instagram,
  ESocialPlatforms.Reddit,
  ESocialPlatforms.Threads,
  ESocialPlatforms.Twitter,
];

export const platformMentionSymbol: Record<ESocialPlatforms, string> = {
  [ESocialPlatforms.Bluesky]: '@',
  [ESocialPlatforms.Facebook]: '@',
  [ESocialPlatforms.GMB]: '--@notSupported--',
  [ESocialPlatforms.Instagram]: '@',
  [ESocialPlatforms.LinkedIn]: '@',
  [ESocialPlatforms.Pinterest]: '--@notSupported--',
  [ESocialPlatforms.Reddit]: 'u/',
  [ESocialPlatforms.Threads]: '@',
  [ESocialPlatforms.TikTok]: '--@notSupported--',
  [ESocialPlatforms.Twitter]: '@',
  [ESocialPlatforms.YouTube]: '--@notSupported--',
  [ESocialPlatforms.Telegram]: '--@notSupported--',
};

export interface IPostsFiltersDrawer {
  dateRange: 'week' | 'month' | 'year' | 'all';
  platforms: ESocialPlatforms[];
  /** Statuses to match, OR-ed together. Empty means no status filter. */
  status: ESocialPostStatus[];
  searchQuery: string;
  isDraft: boolean;
  isOffPlatform: boolean;
  type: EPostType[];
  fromDate: Date | undefined;
  toDate: Date | undefined;
}

export const defaultFilters: IPostsFiltersDrawer = {
  dateRange: 'all',
  platforms: [],
  status: [],
  searchQuery: '',
  isDraft: false,
  isOffPlatform: false,
  type: [],
  fromDate: undefined,
  toDate: undefined,
};

export interface IPed {
  id: number;
  brandId: number;
  topic: string;
  createdAt: string;
  updatedAt: string;
}
